import { config } from '@/config/config'

/**
 * These are exported as objects with a `toString()` rather than plain strings
 * so that every interpolation (e.g. `${MAPS_LITTLE_MONKEY_API_KEY}` in the
 * calls that use them) re-reads the current `config` value, including the
 * `config.json` overlay applied by `loadRuntimeConfig()` — which resolves
 * after this module has already been imported and evaluated.
 */

// Keys

/** Maps Little Monkey API key. */
export const MAPS_LITTLE_MONKEY_API_KEY = {
  toString: () => config.mapsApiKey,
}

// Endpoints

/** Maps Little Monkey endpoint to get an autocompleted address and address data. */
export const MAPS_LITTLE_MONKEY_AUTOCOMPLETE_ENDPOINT = {
  toString: () => config.mapsBaseUrl + '/complete',
}

/** Maps Little Monkey endpoint to get the geo IP data (approx location for user based on IP). */
export const MAPS_LITTLE_MONKEY_GEO_IP_ENDPOINT = {
  toString: () => config.mapsBaseUrl + '/geoip',
}

/** Maps Little Monkey endpoint to reverse geo code/get address data based on latitude and longitude. */
export const MAPS_LITTLE_MONKEY_REVERSE_GEO_CODE_ENDPOINT = {
  toString: () => config.mapsBaseUrl + '/reverse',
}
